import { createSlice } from '@reduxjs/toolkit';
import { performanceRate } from 'lib/performance.rate.js';
import { interactiveCreate } from '../../actions/actions';

const deviceSlice = createSlice({
  name: 'device',
  initialState: {
    /** TODO: It seems that nobody use it anymore, remove.
     * @deprecated
     * */
    performanceRate: performanceRate(),
  },
  reducers: {
    setInfo(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: {
    [interactiveCreate](state, action) {
      const { key_codes, user_info } = action.payload;
      const {
        interactive_platform: platform,
        os,
        model,
        app_version,
      } = user_info;

      return {
        ...state,
        key_codes,
        platform,
        os,
        model,
        app_version,
      };
    },
  },
});

const { reducer, actions } = deviceSlice;

const exports = {
  reducer,
  setInfo: actions.setInfo,
};
export default exports;
